import React, {ReactElement} from "react";
import { Box, createStyles, fade, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export interface DashboardPanelListItemProps {
  children?: ReactElement[] | ReactElement;
  headline?: string;
  imageSlot?: ReactElement;
  contentSlot?: ReactElement;
  actionsSlot: ReactElement;
  actionsDirection?: 'row' | 'column';
  actionsAlign?: string;
  contentBelowImage?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      paddingBottom: theme.spacing(2),
      '&:not(:first-child)': {
        paddingTop: theme.spacing(2)
      },
      '&:not(:last-child)': {
        borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.1)}`
      }
    },
    imageSlot: {
      '& .MuiAvatar-colorDefault': {
        backgroundColor: fade(theme.palette.primary.main, 0.1),
        color: theme.palette.text.primary
      }
    },
    actionSlot: {
      '& .MuiIconButton-root': {
        padding: 0,
        marginLeft: theme.spacing(3)
      }
    },
    actionSlotColumn: {
      [theme.breakpoints.up('md')]: {
        '& .MuiIconButton-root': {
          marginLeft: 0
        }
      }
    }
  }),
);

export const DashboardPanelListItem = (props: DashboardPanelListItemProps) => {

  const classes = useStyles();

  const actionsDirection = props.actionsDirection || 'row'
  const actionsAlign = props.actionsAlign || 'flex-start'

  return (
    <Box className={classes.listItem}>
      <Box display='flex'
           flexDirection={{xs: props.contentBelowImage ? 'row' : 'column', md: 'row'}}
      >
        <Box display='flex' flex='1 1 auto'>
          {props.imageSlot ? (
          <Box flexShrink='0' mr={{xs: 1, md: 3}}
               className={classes.imageSlot}
          >
            {props.imageSlot}
          </Box>
          ) : null }
          <Box flex='1 1 auto'>
            {props.headline ? (
            <Typography color='primary'>
              <strong>
                {props.headline}
              </strong>
            </Typography>
            ) : null }
            {props.contentBelowImage ? null : props.contentSlot }
          </Box>
        </Box>
        {props.actionsSlot ? (
        <Box display='flex'
             alignItems={actionsAlign}
             flexDirection={actionsDirection === 'column'? {xs: 'row', md: 'column'} : null}
             justifyContent={{xs: 'flex-end', md: 'space-between'}}
             className={`${classes.actionSlot} ${actionsDirection === 'column'? classes.actionSlotColumn : null}`}
        >
          {props.actionsSlot}
        </Box>
        ) : null }
      </Box>
      {props.contentBelowImage ? (
      <Box>
        {props.contentSlot}
      </Box>
      ) : null }
    </Box>
  )  
};
